import dataNotFoundIcon from '../../assets/svgs/NotFoundIcon.svg'

const DataNotFound = ({description}) => {
  return (
    <div className='d-flex justify-content-center flex-column gap-4 py-4 no-data-found-container'>
        <div className="desc-container">
            {description ? <p className='my-0 text-muted'>{description}</p>:null}
        </div>
        <div className="not-found-icon-container">
            <img src={dataNotFoundIcon} alt={"Not Found"}/>
        </div>
          <h6 style={{color:"#ccc",fontWeight:"bold",fontStyle:"italic"}} className='my-0'>No Data Found!</h6>
    </div>
  )
}
export default DataNotFound